<template>
  <dataVis></dataVis>
</template>

<script>
import dataVis from '@/components/package/dataVisual.vue';
export default {
  components: {
    dataVis
  },
  name: 'communityVis',
  data () {
    return {};
  },
  mounted () {},
  methods: {}
};

</script>
